import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { FrontEndAPI } from '@business/api/frontend';
import { handleMessage, requestMessage } from '@business/messages';
import { PublicFormsResponse } from '@business/entities/frontend/Forms';

export class ClientFormBloc extends BaseBloc {
  private readonly clientFormRepo = new Repository<PublicFormsResponse>({
    getItemId: form => form.id,
  });

  readonly forms$ = this.clientFormRepo.items$;
  readonly selectForm = this.clientFormRepo.selectItem;

  onReset() {
    this.clientFormRepo.reset();
  }

  fetchForms = () => {
    return FrontEndAPI.fetchForms().pipe(this.clientFormRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_client_forms_error') }));
  };
}
